<template>
  <Form :label-width="100">
    <FormItem label="取章方式：">
      <SelectPro :option-data="deliverTypeList" :valueSelected="currentOrder.deliverType" display-style="button" @on-change="setDeliverType"></SelectPro>
<!--      <RadioGroup v-model="order.deliverType" @on-change="setDeliverType">-->
<!--        <Radio :label="key" v-for="(value,key) in ship.deliverType" :key="key" :true-value="key">-->
<!--          {{key==1?value:value}}-->
<!--        </Radio>-->
<!--      </RadioGroup>-->
    </FormItem>
    <div v-if="currentOrder.deliverType === '0'">
      <FormItem label="承刻企业名称：">{{currentOrder.company.name}}</FormItem>
      <FormItem label="承刻企业电话：">{{currentOrder.company.phone}}</FormItem>
      <FormItem label="取章地址：">
        <span v-dist6nameZh="currentOrder.company.dist6"></span>
        <span>{{currentOrder.company.regAddress}}</span>
      </FormItem>
    </div>

    <div v-if="currentOrder.deliverType === '1'">
       <FormItem label="收件人姓名：">
        <Input v-model="currentOrder.deliverPersonName" placeholder="请输入姓名" style="width: 50%" :disabled="true"></Input>
      </FormItem>
      <FormItem label="收件人电话：">
        <Input v-model="currentOrder.deliverPersonPhone" placeholder="请输入电话" style="width: 50%" :disabled="true"></Input>
      </FormItem>
      <FormItem label="省市区/县：">
        <TuboDist v-model="currentOrder.deliverDist6" dict-name="dist.support" style="width:50%" :clearable="true"></TuboDist>
      </FormItem>
      <FormItem label="详细地址：">
        <Input type="textarea" v-model="currentOrder.deliverAddress" placeholder="请输入详细地址" style="width:50%"></Input>
      </FormItem>
    </div>

    <div v-if="currentOrder.deliverType === '2'">
      <FormItem label="政务大厅名称："></FormItem>
      <FormItem label="政务大厅电话："></FormItem>
      <FormItem label="政务大厅地址："></FormItem>
    </div>
  </Form>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    name: 'OrderSelectDeliver',
    data() {
      return {
        deliverTypeList: [{value: '0', label: '到店自取'}, {value: '1', label: '快递'}],
      }
    },
    computed: {
      ...mapState({
        currentOrder: state => state.order.currentOrder,
      }),
    },
    methods: {
      // 选择收货方式
      setDeliverType(item) {
        this.currentOrder.deliverType = item.value
        // Object.assign(this.order, {
        //   deliverPersonName: this.order.deliverType == 1 ? this.order.crpName : '',
        //   deliverPersonPhone: this.order.deliverType == 1 ? this.order.crpPhone : ''
        // })
      },

      // setDevliverType() {
      //   dict.dict('EntityGzwOrder_deliverType').then(payload => {
      //     const arr = [], arr1 = []
      //     if (this.order.company.bizSetupJsonStr && this.order.company.bizSetupJsonStr.deliver) {
      //       if (this.order.company.bizSetupJsonStr.deliver.shop) arr.push(Object.entries(payload.content)[0])
      //       if (this.order.company.bizSetupJsonStr.deliver.express) arr.push(Object.entries(payload.content)[1])
      //       if (this.order.company.bizSetupJsonStr.deliver.center) arr.push(Object.entries(payload.content)[2])
      //       this.centerAddress = this.order.company.bizSetupJsonStr.deliver.centerAddress
      //       const obj = {}
      //       arr.forEach(item => {
      //         obj[item[0]] = item[1]
      //       })
      //       this.ship.deliverType = obj
      //     } else {
      //       arr1.push(Object.entries(payload.content)[0])
      //       arr1.push(Object.entries(payload.content)[1])
      //       const obj1 = {}
      //       arr1.forEach(item => {
      //         obj1[item[0]] = item[1]
      //       })
      //       this.ship.deliverType = obj1
      //     }
      //   })
    },
    created() {
      if (!this.currentOrder.deliverType)
        this.currentOrder.deliverType = '0'

      this.currentOrder.deliverPersonName = this.currentOrder.crpName
      this.currentOrder.deliverPersonPhone = this.currentOrder.crpPhone
    }
  }
</script>
